export default __webpack_public_path__ + "static/media/creditcardchoices-icon.9af51a6c.png";